module.exports = __webpack_public_path__ + "img/businessman-completing-task 3.aa0ec218.png";